/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'checkmark-filled': {
    viewBox: '0 0 32 32',
    data: `<path d="M16,1C7.7,1,1,7.7,1,16c0,8.3,6.7,15,15,15c8.3,0,15-6.7,15-15C31,7.7,24.3,1,16,1z M23.8,10.6l-9.6,11.8l-5.8-4.6 c-0.4-0.3-0.5-1-0.2-1.4c0.3-0.4,1-0.5,1.4-0.2l4.2,3.4l8.4-10.2c0.4-0.4,1-0.5,1.4-0.1S24.1,10.2,23.8,10.6z"/>`
  }
})
